export default __webpack_public_path__ + "static/media/hero-avatar-1.dd4d12ae.jpg";